<template>
    <div class="ufo--fs-loader" role="status" aria-live="polite">
        <div class="ufo--fs-loader__panel">
            <img :src="loaderAnimation" class="ufo--fs-loader__spinner" alt="" aria-hidden="true" />
            <p v-if="visibleMessage">{{ visibleMessage }}</p>
        </div>
    </div>
</template>

<script>
    import loaderAnimation from "@/images/loadinganim.gif";

    const loaderMessages = [
        'Painting the screens...',
        'Moving numbers...',
        'Polishing pixels...',
        'Tuning the grid...',
        'Preparing your workspace...',
        'Lining things up...',
    ];

    export default {
        name: "full-screen-loader",
        data() {
            return {
                loaderAnimation,
                loaderMessageIndex: Math.floor(Math.random() * loaderMessages.length),
                loaderMessageTimer: null,
            }
        },
        mounted() {
            this.loaderMessageTimer = setInterval(() => {
                let nextIndex = Math.floor(Math.random() * loaderMessages.length);
                if (nextIndex === this.loaderMessageIndex) {
                    nextIndex = (nextIndex + 1) % loaderMessages.length;
                }
                this.loaderMessageIndex = nextIndex;
            }, 2200);
        },
        unmounted() {
            if (this.loaderMessageTimer) {
                clearInterval(this.loaderMessageTimer);
            }
            this.$store.state.loaderMessage = null;
        },
        computed: {
            visibleMessage() {
                return this.$store.state.loaderMessage || loaderMessages[this.loaderMessageIndex];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ufo--fs-loader {
        align-items: center;
        background-color: rgba(15, 15, 15, 0.75);
        display: flex;
        height: 100%;
        justify-content: center;
        left: 50%;
        margin: 0 auto;
        opacity: 1;
        position: fixed;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: opacity .2s ease-in-out;
        width: 100%;
        z-index: 103;
    }

    .ufo--fs-loader__panel {
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: 360px;
        text-align: center;
        width: min(100%, 360px);

        p {
            color: rgba(255, 255, 255, 0.82);
            font: var(--editor-ui-b2-regular);
            line-height: 1.45;
            margin: 0;
            text-align: center;
        }
    }

    .ufo--fs-loader__spinner {
        height: 80px;
        width: 80px;
    }
</style>
